import { useQuery } from "react-query"
import { getResearcherBibliometrics } from "../../api/rs/researcherBibliometrics.api"

export const useResearcherBibliometrics = (crisId) => {
    return useQuery('/researcher/bibliometrics', () => getResearcherBibliometrics(crisId))
}